import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lumerai'),
      meta: {
        permissions: ['administrator', 'lumerai_manage'],
        featureFlag: FEATURE_FLAGS.LUMERAI,
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'LUMERAI_SETTINGS.TITLE',
        icon: 'i-lucide-bot',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'lumerai_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator', 'lumerai_manage'],
            featureFlag: FEATURE_FLAGS.LUMERAI,
            installationTypes: [
              INSTALLATION_TYPES.ENTERPRISE,
              INSTALLATION_TYPES.CLOUD,
            ],
          },
        },
      ],
    },
  ],
};
